import(/* webpackMode: "eager" */ "/vercel/path0/src/app/discuss/page.tsx");
